'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _Close = require('./Close');

var _Close2 = _interopRequireDefault(_Close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var className = {
  base: 'quiver-modal-container__container',
  afterOpen: 'quiver-modal-container__container--after-open',
  beforeClose: 'quiver-modal-container__container--before-close'
};

var overlayClassName = {
  base: 'quiver-modal-container',
  afterOpen: 'quiver-modal-container--after-open',
  beforeClose: 'quiver-modal-container--before-close'
};

/**
 * @description The ModalContainer component is the controller for an individual Modal.
 * The Modal's content can be passed a child prop to the container.
 *
 * @param {object} props
 * @param {string} props.contentLabel string for the aria-label
 * @param {function} props.onClose optional function called upon closing the modal
 * @param {boolean} props.isOpen boolean flag for showing the modal
 */

var ModalContainer = function (_Component) {
  (0, _inherits3.default)(ModalContainer, _Component);

  function ModalContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ModalContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModalContainer.__proto__ || (0, _getPrototypeOf2.default)(ModalContainer)).call.apply(_ref, [this].concat(args))), _this), _this.closeOnEscapeKey = function (_ref2) {
      var key = _ref2.key;

      if (key === 'Escape') {
        _this.props.onClose();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ModalContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keyup', this.closeOnEscapeKey);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keyup', this.closeOnEscapeKey);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          onClose = _props.onClose,
          contentLabel = _props.contentLabel;


      return _react2.default.createElement(
        _reactModal2.default,
        {
          isOpen: isOpen,
          onRequestClose: onClose,
          contentLabel: contentLabel,
          className: className,
          overlayClassName: overlayClassName
        },
        _react2.default.createElement(
          'div',
          { className: 'quiver-modal-container__body' },
          _react2.default.createElement(_Close2.default, { onClick: onClose }),
          this.props.children
        )
      );
    }
  }]);
  return ModalContainer;
}(_react.Component);

ModalContainer.propTypes = {
  contentLabel: _propTypes2.default.string.isRequired,
  isOpen: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func,
  children: _propTypes2.default.node.isRequired
};
ModalContainer.defaultProps = {
  onClose: null
};
exports.default = ModalContainer;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ModalContainer/ModalContainer.js
// module id = 607
// module chunks = 11